import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full border text-sm font-medium transition-colors cursor-pointer disabled:pointer-events-none disabled:opacity-50 outline-none focus-visible:ring-2 focus-visible:ring-ring",
  {
    variants: {
      variant: {
        outline: "border-[var(--text-secondary)] bg-transparent text-foreground hover:border-foreground hover:bg-muted",
        primary: "border-primary bg-primary text-primary-foreground hover:border-[var(--accent-hover)] hover:bg-[var(--accent-hover)]",
        danger: "border-destructive bg-destructive text-white hover:brightness-95",
        ghost: "border-transparent bg-transparent text-muted-foreground hover:bg-muted hover:text-foreground",
      },
      size: {
        default: "px-5 py-2",
        sm: "px-3 py-1 text-xs",
      },
    },
    defaultVariants: { variant: "outline", size: "default" },
  },
);

function Button({
  className, variant, size, asChild = false, ...props
}: React.ComponentProps<"button"> & VariantProps<typeof buttonVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot : "button";
  return <Comp data-slot="button" className={cn(buttonVariants({ variant, size }), className)} {...props} />;
}

export { Button, buttonVariants };
